module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/is-iterable.js
// module id = 1364
// module chunks = 0